import type { InlineKindEntry, InlineMatch } from '../inline-markup-types';

export type InlineMarkupRegistry = {
  parseTokens: (text: string) => InlineMatch[];
};

// Which kinds are live is the caller's choice: a surface with no sources to cite registers `pill` alone
// and never pulls the citation layer in behind it.
export const createInlineMarkupRegistry = (kinds: InlineKindEntry[]): InlineMarkupRegistry => {
  const markers = kinds.map(entry => entry.marker);

  return {
    parseTokens: text => {
      if (!markers.some(marker => text.includes(marker))) return [];

      const parsed = kinds
        .flatMap(entry => entry.parse(text).map(match => ({ ...match, entry })))
        .sort((a, b) => a.index - b.index);

      // The two syntaxes can't really overlap, but just in case: keep the leftmost and skip anything
      // that overlaps it, so one token never eats another.
      const result: InlineMatch[] = [];
      let cursor = -1;
      for (const item of parsed) {
        if (item.index < cursor) continue;
        result.push(item);
        cursor = item.index + item.raw.length;
      }
      return result;
    },
  };
};
